import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { safeBoolean } from '../../utils/utils'

export interface IXRayBadgeProps {
  isXRay?: boolean
}

export const XRay = ({ isXRay }: IXRayBadgeProps) => (
  safeBoolean(isXRay) && (
    <Badge use={badges.BORDERED_TEXT}>
      <span data-automation-id="x-ray-badge">X-Ray</span>
    </Badge>) || null
)
